import * as actionTypes from '../actions/actionTypes';

const initialState = {
  creditApplicationId: '',
  bankAccounts: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_NORDIGEN_CREDIT_APLICATION_ID_SUCCESS: {
      return {
        ...state,
        creditApplicationId: action.result.data.creditApplicationId,
      };
    }
    case actionTypes.POST_NORDIGEN_STANDALONE_BANK_SUCCESS: {
      return {
        ...state,
        nordigenInitiateLink: action.result.data.initiate,
      };
    }
    case actionTypes.GET_NORDIGEN_STANDALONE_ACCOUNT_SUCCESS: {
      return {
        ...state,
        bankAccounts: action.result.data,
      };
    }
    default:
      return state;
  }
}
